//CSSをバンドル
import 'Src/scss/rental-top.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'


let rentalTopTitleWrap = document.getElementById('practice');
let teacherRental = rentalTopTitleWrap.previousElementSibling;

console.log(teacherRental);
teacherRental.classList.add('teacher___rental');

